import { gql } from '@apollo/client';

const pageStructureQuery = gql`
  {
    pages(first: 500) {
      nodes {
        uri
        slug
        template {
          templateName
        }
      }
    }
    menuItems(first: 100) {
      nodes {
        id
        path
        label
        uri
        parentId
        childItems(first: 100) {
          nodes {
            id
            label
            path
            uri
            parentId
            childItems(first: 100) {
              nodes {
                id
                label
                path
                uri
              }
            }
          }
        }
      }
    }
    organization {
      fields {
        address {
          city
          country
          street
          zip
        }
        phone {
          label
          value
        }
        name {
          label
          value
        }
        logo {
          node {
            sourceUrl
            title
          }
        }
        consent {
          label
          value
        }
        email {
          label
          value
        }
      }
    }
  }
`;

export default pageStructureQuery;
